import { Box, Chip, IconButton, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { ColorModeContext, tokens } from "../theme";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const pageLabels = {
  "/home": "Dashboard",
  "/clients": "Klientet",
  "/clientform": "Shto Klient",
  "/pos": "Pikat",
  "/posform": "Shto Pike",
  "/offers": "Ofertat",
  "/offerform": "Shto Oferte",
  "/transactions": "Transaksionet",
  "/bonuspointsvalue": "Vlera e Pikeve",
  "/voucher": "Voucherat",
  "/customergroup": "Groupet",
  "/customergroupform": "Shto Group",
  "/notifications": "Notifikimet",
  "/notificationsform": "Shto Notifikim",
  "/banners": "Banerat",
  "/nettingreport": "Barazimet",
  "/levels": "Levelet",
};

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pageTitle = pageLabels[location.pathname.toLowerCase()] || "Hill Group CMS";

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    Cookies.remove("token");
    navigate("/");
    window.location.reload(true);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
      sx={{
        background: theme.palette.mode === "dark" ? "rgba(19,23,32,0.86)" : "rgba(255,255,255,0.86)",
        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(17,19,24,0.08)"}`,
        borderRadius: "14px",
        minHeight: 66,
        px: { xs: 1.5, sm: 2 },
        position: "sticky",
        top: 0,
        zIndex: 30,
        backdropFilter: "blur(18px)",
      }}
    >
      <Box>
        <Typography variant="h4" color={colors.grey[100]}>
          {pageTitle}
        </Typography>
        <Typography variant="caption" color={colors.grey[500]} fontWeight={600}>
          Hill Group loyalty administration
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        <Chip
          label="API connected"
          size="small"
          sx={{
            background: theme.palette.mode === "dark" ? "rgba(22,163,116,0.12)" : "rgba(22,163,116,0.1)",
            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(22,163,116,0.22)" : "rgba(22,163,116,0.18)"}`,
            color: colors.greenAccent[500],
            display: { xs: "none", sm: "inline-flex" },
            fontWeight: 800,
          }}
        />
        <IconButton
          onClick={colorMode.toggleColorMode}
          sx={{
            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(17,19,24,0.08)"}`,
            color: colors.grey[100],
          }}
        >
          {theme.palette.mode === "dark" ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
        </IconButton>
        <IconButton
          onClick={handleClick}
          sx={{
            background: colors.primary[100],
            color: "#ffffff",
            "&:hover": { background: colors.primary[200] },
          }}
        >
          <AccountCircleOutlinedIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={handleClose}>Account</MenuItem>
          <MenuItem onClick={handleLogout}>
            <LogoutOutlinedIcon fontSize="small" style={{ marginRight: 8 }} />
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Topbar;
